import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import { getTranslation } from "@utils/Translations"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, usePostTitleEditor } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Blog Author",
}

export default defineBlock("section/blog-author", (props) => {
  const author = props.blog?.headerData?.authorPage?.[0]
  const socials = author?.headerData?.socials || []

  return (
    author && (
      <Appear className={cn("blog-author relative my-9")}>
        <div className="w-full max-w-blogPostLargeTextW bg-grey-0 rounded-md mx-auto flex flex-col p-5 md:p-6 gap-5">
          <div className="w-full flex gap-5 md:gap-6 items-center">
            {author?.featuredImage?.node.mediaItemUrl && (
              <ResponsiveImage {...author.featuredImage.node} className="size-authorPageFeaturedImage" />
            )}
            <div className="flex flex-col gap-2 items-start">
              <p className="type-header-m" dangerouslySetInnerHTML={{ __html: author?.title || "" }} />
              {author?.headerData?.role && (
                <p className="type-special-pill-title-l-mobile md:type-special-pill-title-l text-grey-2">
                  {author.headerData.role}
                </p>
              )}
              {author?.excerpt && (
                <p
                  className="hidden md:block type-body-s text-grey-2"
                  dangerouslySetInnerHTML={{ __html: author.excerpt || "" }}
                />
              )}
              <div className="hidden md:flex items-end justify-end w-full gap-2 mt-2">
                <Link href={author?.uri || ""} className="type-ui-button-s">
                  {getTranslation("authorLearnMore", "More about the author")}
                </Link>
              </div>
            </div>
          </div>
          <div className="flex md:hidden flex-col gap-5 items-start">
            {author?.excerpt && (
              <p className="type-body-s text-grey-2" dangerouslySetInnerHTML={{ __html: author.excerpt || "" }} />
            )}
            <div className="flex items-end justify-end w-full gap-2 mt-2">
              <Link href={author?.uri || ""} className="type-ui-button-s">
                {getTranslation("authorLearnMore", "More about the author")}
              </Link>
            </div>
          </div>
        </div>
      </Appear>
    )
  )
})
